// extracted by css-extract-rspack-plugin
export default {"configurer":"configurer-c9NGB6 configurer-GIgjMb","titlebar":"titlebar-tn4qgQ titlebar-JfxvqY"};